module.exports = __webpack_public_path__ + "static/media/electric-car.f24ada00.png";